
import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import { BaseUrls } from '../utils/base-urls';
import { globalSetSessionExpired } from '../providers/TokenProvider';

// const ClientsAxios: any = {};
// Object.keys(BaseUrls).forEach((base: any) => {
//     ClientsAxios[base] = axios.create({ baseURL: BaseUrls[base].url });
//     addInterceptor(ClientsAxios[base], BaseUrls[base].config);
// });

// function addInterceptor(instance: AxiosInstance, requestExtension: any): AxiosInstance {
//     instance.interceptors.request.use(
//         async (request: InternalAxiosRequestConfig) => {
//             const token = localStorage.getItem('auth_token');
//             const tokenExpiry = localStorage.getItem('token_expiry');
//             const now = Date.now();

//             // Check if token is expired before adding to headers
//             if (token && tokenExpiry && now < parseInt(tokenExpiry)) {
//                 request.headers['Authorization'] = token;
//             } else {
//                 localStorage.removeItem('auth_token');
//                 localStorage.removeItem('token_expiry');
//             }

//             request.headers['Accept'] = 'Application/json';
//             if (!request.headers['Content-Type']) request.headers['Content-Type'] = 'application/json';
//             return request;
//         },
//         (error: any) => {
//             return Promise.reject(new Error(error));
//         }
//     );

//     instance.interceptors.response.use(
//         (response: any) => response,
//         (error: { response: { data: any; status: number } }) => {
//             if (error?.response?.status === 401) {
//                 localStorage.removeItem('auth_token');
//                 localStorage.removeItem('token_expiry');
//                 localStorage.removeItem('chat_session');
//                 window.dispatchEvent(new CustomEvent('aiKhetiGaadi:sessionExpired', { detail: { message: 'Token expired or invalid' } }));
//             }
//             return Promise.reject(new Error(error?.response?.data?.message || 'Something went wrong'));
//         }
//     );

//     return instance;
// }

// export default ClientsAxios;

const ClientsAxios: any = {};
Object.keys(BaseUrls).forEach((base: any) => {
    ClientsAxios[base] = axios.create({ baseURL: BaseUrls[base].url });
    addInterceptor(ClientsAxios[base], BaseUrls[base].config);
});

function addInterceptor(instance: AxiosInstance, requestExtension: any): AxiosInstance {
    instance.interceptors.request.use(
        async (request: InternalAxiosRequestConfig) => {
            const token = localStorage.getItem('auth_token');
            const tokenExpiry = localStorage.getItem('token_expiry');
            const now = Date.now();
            
            if (token && tokenExpiry && now < parseInt(tokenExpiry)) {
                request.headers['Authorization'] = token;
            } else {
                localStorage.removeItem('auth_token');
                localStorage.removeItem('token_expiry');
            }

            request.headers['Accept'] = 'Application/json';
            if (!request.headers['Content-Type']) request.headers['Content-Type'] = 'application/json';
            return request;
        },
        (error: any) => {
            return Promise.reject(new Error(error));
        }
    );

    instance.interceptors.response.use(
        (response: any) => response,
        (error: { response: { data: any; status: number } }) => {
            if (error?.response?.status === 401) {
                localStorage.removeItem('auth_token');
                localStorage.removeItem('token_expiry');
                localStorage.removeItem('chat_session');
                globalSetSessionExpired(true);
            }
            return Promise.reject(new Error(error?.response?.data?.message || 'Something went wrong'));
        }
    );

    return instance;
}

export default ClientsAxios;